var MockConnectIframeInterface = /** @class */ (function () {
    function MockConnectIframeInterface() {
        this.id = 'mock-iframe-id';
        this.src = 'mock-iframe-src';
        this.name = 'mock-iframe-name';
    }
    return MockConnectIframeInterface;
}());
export { MockConnectIframeInterface };
//# sourceMappingURL=MockConnectIframeInterface.js.map